module.exports = "https://static.wmbcdn.com/uniweb/images/3ec98faa2e687384d13aaa632dc1fcc3.webp";